export const arrangeDocTypePills = types => [
  ...types,
  { id: null, name: "All Types" },
];

export const makeDocTitle = (
  opportunityName,
  selectedCategoryID,
  documentTypes,
  res,
) => {
  const docTypePattern = documentTypes.find(dt => dt.id === selectedCategoryID)
    .id_pattern;
  return `${opportunityName.replace(/ +/g, "").slice(0, 15)}-${
    docTypePattern.split("-")[0]
  }-${res.slice(-3)}`;
};



// WEBPACK FOOTER //
// ./src/components/CreateDocPopup/methods.js